import React, { useState, ChangeEvent, FormEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { registerUser } from '../Data/dataApi'; // Importer la fonction d'enregistrement
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
// import { CLIENT_RENEG_LIMIT } from 'tls';
// import { clearScreenDown } from 'readline';
// import { useAuth } from "../Auth/autoContext";

const RegisterForm: React.FC = () => {
    const [formData, setFormData] = useState({
        userName: '',
        password: '',
        confirmPassword: '',
        firstName: '',
        lastName: '',
        phone: '',
        address: '',
        postalCode: '',
        city: ''
    });

    const location = useLocation();
    const isPrevisionLink = location.state?.isPrevisionLink ?? false;

    // const [subscriptionType, setSubscriptionType] = useState<'free' | 'premium'>('free');
    const [errors, setErrors] = useState<any>({});
    // const { login } = useAuth();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);

    // Fonction pour gérer les changements dans le formulaire
    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const [acceptedPrivacy, setAcceptedPrivacy] = useState(false);


    // const handleSubscriptionChange = (e: ChangeEvent<HTMLInputElement>) => {
    //     setSubscriptionType(e.target.value as 'free' | 'premium');
    // };

    // Validation du formulaire
    const validateForm = (): boolean => {
        let valid = true;
        const newErrors: any = {};

        if (!formData.userName) {
            newErrors.userName = t('registerform.error-email2');
            valid = false;
        }
        if (!formData.password) {
            newErrors.password = t('registerform.error-password2');
            valid = false;
        } else {
            // Regex pour vérifier Majuscule + Minuscule + Chiffre + Caractère spécial
            const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).+$/;
            if (!passwordRegex.test(formData.password)) {
                newErrors.password = t('registerform.error-password1');
                valid = false;
            }
        }
        if (!formData.confirmPassword) {
            newErrors.confirmPassword = "Confirmation requise";
            valid = false;
        } else if (formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = "Les mots de passe ne correspondent pas";
            valid = false;
        }
        if (!formData.firstName) {
            newErrors.firstName = t('registerform.error-firstname');
            valid = false;
        }
        if (!formData.lastName) {
            newErrors.lastName = t('registerform.error-lastname');
            valid = false;
        }
        if (!formData.phone) {
            newErrors.phone = t('registerform.error-phone');
            valid = false;
        }
        if (!formData.address) {
            newErrors.address = t('registerform.error-address');
            valid = false;
        }
        if (!formData.postalCode) {
            newErrors.postalCode = t('registerform.error-zipCode');
            valid = false;
        }
        if (!formData.city) {
            newErrors.city = t('registerform.error-city');
            valid = false;
        }
        if (!acceptedPrivacy) {
            newErrors.privacy = t('registerform.error-privacy');
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    };

    // Fonction pour gérer la soumission du formulaire
    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!validateForm()) return;

        setLoading(true);  // 🔥 start loading

        const { confirmPassword, ...dataToSend } = formData;

        try {
            const result = await registerUser({
                ...dataToSend,
                acceptedPrivacy: acceptedPrivacy,
                role: 'public' // 👈 envoyé explicitement au backend
            });

            if (result.success) {
                navigate('/verify-email', { state: { email: formData.userName } });
            } else {
                setErrors({ ...errors, submit: result.message });
            }
        }
        catch {
            setLoading(true);  // 🔥 start loading
        }
        finally {
            setLoading(false); // 🔥 stop loading
        }
    };

    return (
        <>
              <Helmet>
                <title>
                  Sign up | Stockifly
                </title>
        
                <meta
                  name="description"
                  content="Sign up to Stockifly"
                />
              </Helmet>

            <div className="container-form">
                {isPrevisionLink ? (
                    <h2 id='form-subtitle'>{t('registerform.subtitle')} <br /><span>{t('registerform.subtitleFree')}</span></h2>
                ) : (
                    <h2 id='form-title'>{t('registerform.title')}</h2>
                )}
                <form className="register-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>{t('registerform.email')}</label>
                        <input type="email" name="userName" placeholder={t('registerform.input-email')} autoCapitalize="none" autoCorrect="off" spellCheck={false} value={formData.userName} onChange={handleChange} />
                        {errors.userName && <p className="error">{errors.userName}</p>}
                    </div>
                    <div className="form-group">
                        <label>{t('registerform.password')}</label>
                        <input type="password" name="password" placeholder={t('registerform.input-password')} value={formData.password} onChange={handleChange} autoComplete="new-password" />
                        {errors.password && <p className="error">{errors.password}</p>}
                    </div>
                    <div className="form-group">
                        <label>{t('registerform.confirmPassword')}</label>
                        <input type="password" name="confirmPassword" placeholder={t('registerform.input-confirmPassword')} value={formData.confirmPassword} onChange={handleChange} />
                        {errors.confirmPassword && <p className="error">{errors.confirmPassword}</p>}
                    </div>
                    <div className="form-group">
                        <label>{t('registerform.firstname')}</label>
                        <input type="text" name="firstName" placeholder={t('registerform.input-firstname')} value={formData.firstName} onChange={handleChange} />
                        {errors.firstName && <p className="error">{errors.firstName}</p>}
                    </div>
                    <div className="form-group">
                        <label>{t('registerform.lastname')}</label>
                        <input type="text" name="lastName" placeholder={t('registerform.input-lastname')} value={formData.lastName} onChange={handleChange} />
                        {errors.lastName && <p className="error">{errors.lastName}</p>}
                    </div>
                    <div className="form-group">
                        <label>{t('registerform.phone')}</label>
                        <input type="text" name="phone" placeholder={t('registerform.input-phone')} value={formData.phone} onChange={handleChange} />
                        {errors.phone && <p className="error">{errors.phone}</p>}
                    </div>
                    <div className="form-group">
                        <label>{t('registerform.address')}</label>
                        <input type="text" name="address" placeholder={t('registerform.input-address')} value={formData.address} onChange={handleChange} />
                        {errors.address && <p className="error">{errors.address}</p>}
                    </div>
                    <div className="form-group">
                        <label>{t('registerform.zipCode')}</label>
                        <input type="text" name="postalCode" placeholder={t('registerform.input-zipCode')} value={formData.postalCode} onChange={handleChange} />
                        {errors.postalCode && <p className="error">{errors.postalCode}</p>}
                    </div>
                    <div className="form-group">
                        <label>{t('registerform.city')}</label>
                        <input type="text" name="city" placeholder={t('registerform.input-city')} value={formData.city} onChange={handleChange} />
                        {errors.city && <p className="error">{errors.city}</p>}
                    </div><br />


                    <button className={`button-blue ${loading ? 'loading' : ''}`} id='button-register' type="submit" disabled={loading} >{loading ? "" : t('registerform.button')}</button>
                    {errors.submit && <p className="error">{errors.submit}</p>} <br />
                    <p className="register-link"><span>
                        {t('registerform.already-account')}</span><br />
                        <a href="/login">{t('registerform.login')}</a>
                    </p>
                </form><br />
                <div className="checkbox-group">
                    <label className="checkbox-label">
                        <input
                            type="checkbox"
                            id='login-checkbox-input'
                            checked={acceptedPrivacy}
                            onChange={(e) => setAcceptedPrivacy(e.target.checked)}
                        />
                        <span className="checkbox-text">
                            {t('registerform.accept-privacy')}{' '}
                            <Link to="/rights">{t('registerform.privacy')}</Link>
                        </span>
                    </label>
                    {errors.privacy && <p className="error-dark">{errors.privacy}</p>}
                </div>
                <br />
            </div>
        </>
    );
};

export default RegisterForm;
